import React from 'react';
import send from 'react-send';
import MainTitle from '../MainTitle';
import Refresh from '../Refresh';

export const Title = send('Title');

export const Subtitle = send('Subtitle');

export default (props) => (
	<>
		<MainTitle>
			<Title.Output />
			<Subtitle.Output />
			{props.children}
		</MainTitle>
		<Refresh canUpdate={props.canUpdate} onClick={props.load} />
	</>
)
